var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-space-between align-center py-1"},[_c('div',[_vm._v(_vm._s(_vm.label))]),_c('v-switch',{staticClass:"ma-0",attrs:{"color":"primary","inset":"","ripple":false,"hide-details":""},model:{value:(_vm.themetoggler),callback:function ($$v) {_vm.themetoggler=$$v},expression:"themetoggler"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }